import { z } from 'zod';

export const BankSchema = z.object({
  bankCode: z.string(),
  bankName: z.string()
});

export const BanksApiResponseSchema = z.object({
  status: z.number().int(),
  message: z.string(),
  data: z.array(BankSchema)
});

export type Bank = z.infer<typeof BankSchema>;
export type BanksApiResponse = z.infer<typeof BanksApiResponseSchema>;
